import { Controller } from "@hotwired/stimulus"
import React from "react"
import ReactDOM from "react-dom/client"
import Wallets3DScene from "../components/wallets-3d-scene"

export default class extends Controller {

  connect() {
    this.root = ReactDOM.createRoot(this.element)
    this.root.render(
      <Wallets3DScene/>
    )
  }

  disconnect() {
     this.root.unmount()
  }
  
}
